import { DatePicker, Form, Input, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import rpmService from "../../../../../Services/rpmService";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRpmAlertsList,
  setSelectedRpmPatient,
} from "../../../../../Redux/actions/rpmActions";
import { convertUTCDate } from "../../../../../utils/convertionFunc";

function NewAlert({ handleClose }) {
  const [loader, setLoader] = useState(false);
  const formRef = useRef();
  const { selectedRpmPatient } = useSelector((state) => state.rpm);
  const dispatch = useDispatch();
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = sessionStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const handleAlertCreate = async () => {
    const { date, subject, content } = formRef.current.getFieldsValue();

    if (!date || !subject || !content) {
      message.error("Please fill in mandatory fields");
      return;
    }
    setLoader(true);
    const payload = {
      account_Id: selectedRpmPatient.account_Id,
      clinic_id: selectedRpmPatient.clinic_Id,
      content,
      createdBy: loggedUser?.user?.userId,
      createdDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      date: convertUTCDate(date, "YYYY-MM-DD HH:mm:ss"),
      modifiedBy: loggedUser?.user?.userId,
      modifiedDate: convertUTCDate(new Date(), "YYYY-MM-DD HH:mm:ss"),
      patientId: selectedRpmPatient.patientId,
      status: 1,
      subject,
      trigeredBy: loggedUser?.user?.userId,
      trigeredTo: selectedRpmPatient.patientId,
      userId: selectedRpmPatient.createdBy,
      rpmApplicable: "Y",
    };
    try {
      await rpmService.addNewAlert(payload);
      message.success("Alert created successfully.");
      setLoader(false);
      const alertsPayload = {
        patientId: selectedRpmPatient.patientId,
        rpmApplicable: "Y",
        status: 1,
      };
      dispatch(fetchRpmAlertsList(alertsPayload));
      handleClose();
    } catch (e) {
      console.error(e);
      setLoader(false);
    }
  };

  return (
    <>
      <Form layout="vertical" ref={formRef}>
        <div className="grid grid-cols-2 items-center gap-4">
          <div>
            <Form.Item
              label={
                <span>
                  Date<span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="date"
            >
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="MM-DD-YYYY"
              />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Subject <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="subject"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label={
                <span>
                  Content <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="content"
            >
              <Input placeholder="Enter" />
            </Form.Item>
          </div>
        </div>
      </Form>
      <div className="flex items-center w-full justify-end my-5">
        <button
          onClick={handleClose}
          className="border-brand-primaryColor bg-white border rounded text-brand-primaryColor text-sm px-6 py-1"
        >
          Cancel
        </button>
        <button
          disabled={loader}
          onClick={handleAlertCreate}
          className="bg-brand-primaryColor text-white border-brand-primaryColor border rounded px-5 py-1 text-brand-textWhite text-sm ml-3 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Submit
        </button>
      </div>
    </>
  );
}

export default NewAlert;
